<template>
  <el-dialog
    :title="'打印面单（理货单号：'+ config.tallyOrderCode +'）——共'+ list.length + '条记录' "
    :visible.sync="visible"
    append-to-body
    width="1100px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-table
      ref="table"
      v-loading="loading"
      border
      :data="list"
      max-height="720px"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange">
      <el-table-column
        :selectable="(row)=> row.status !== 9 && row.transType !== 3"
        type="selection"
        fixed="left"
        width="40">
      </el-table-column>
      <el-table-column
        type="index"
        label="序号"
        fixed="left"
        width="50">
      </el-table-column>
      <el-table-column
        label="发货单号"
        fixed="left"
        :resizable="false"
        width="145"
        prop="code">
      </el-table-column>
      <el-table-column
        label="仓库"
        :resizable="false"
        min-width="130"
        prop="warehouseNo">
        <template slot-scope="{row}">
          {{ row.warehouseNo | warehouseName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="订单来源"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.orderSource | sourceName() }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="出库类型"
        :resizable="false"
        width="70"
        prop="type">
        <template slot-scope="{row}">
          {{ row.type| outTypeName() }}
        </template>
      </el-table-column> -->
      <el-table-column
        label="出库状态"
        :resizable="false"
        width="70"
        prop="status">
        <template slot-scope="{row}">
          <span :style="{color: row.status === 9 ? 'red': '#606266'}">{{ row.status | outStatusName() }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="物流模板"
        :resizable="false"
        min-width="160"
        prop="packageNum">
        <template slot-scope="{row}">
          <el-popover
            v-if="row.needInputWeightAndVolume === 1"
            placement="top-start"
            title="包裹信息"
            width="100"
            trigger="hover">
            <el-form
              label-width="45px"
              class="package-info">
              <el-form-item
                label="体积:"
                style="margin-bottom: 0">{{ row.volume || row.defaultVolume }}立方米</el-form-item>
              <el-form-item
                label="重量:"
                style="margin-bottom: 0">{{ row.volume || row.defaultWeight }}公斤</el-form-item>
            </el-form>
            <div slot="reference">
              <i class="el-icon-info"></i>
              <span>{{ row.expressCode | expressName() }}</span>
            </div>
          </el-popover>
          <span v-else>{{ row.expressCode | expressName() }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="打单状态"
        :resizable="false"
        prop="printStatus"
        width="90">
        <template slot-scope="{row}">
          <span
            v-if="row.transType !== 3"
            :style="{color: row.printStatus === 9 ? 'red' : ''}">
            {{ row.printStatus | printStatusName() }}
            <!-- <el-tooltip
              v-if="row.printStatus === 9"
              effect="dark"
              :content="row.printErrorMsg"
              placement="top-start">
              <i
                class="el-icon-question"
                style="cursor:pointer"></i>
            </el-tooltip> -->
            <el-popover
              v-if="row.printStatus === 9"
              placement="top-start"
              title="错误信息"
              width="200"
              trigger="hover"
              :content="row.printErrorMsg">
              <i
                slot="reference"
                class="el-icon-question"
                style="cursor:pointer"></i>
            </el-popover>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        :resizable="false"
        width="145">
        <template slot-scope="{row}">
          {{ row.createTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        fixed="right"
        width="105">
        <template slot-scope="{row}">
          <el-button
            v-if="row.needInputWeightAndVolume === 1 && row.status !== 9 && row.transType !== 3"
            type="warning"
            @click.native="setweightandvolume(row)">
            设置包裹
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <batch-express-btn
        :disabled="multipleSelection.length === 0"
        :showCount="multipleSelection.length > 0"
        :selection="multipleSelection"
        :callback="resetFetch" />
    </span>
    <set-weight-modal
      ref="weight"
      :callback="fetchList" />
  </el-dialog>
</template>
<script>
import BatchExpressBtn from '../../components/batch-express-btn.vue'
import SetWeightModal from '../outstock/busi/set-weight-modal.vue'

export default {
  name: 'OutSelectModal',
  components: { SetWeightModal, BatchExpressBtn },
  props: {
    callback: {
      type: Function
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 100000,
        tallyOrderCode: ''
      },
      list: [],
      multipleSelection: []
    }
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.status === 9) {
        return 'warning-row-cus'
      }
      if (row.status === 2) {
        return 'success-row-cus'
      }
      return ''
    },
    setweightandvolume(row) {
      console.log(row)
      const { defaultVolume, volume, defaultWeight, weight, sendOrderId, code, expressCode } = row
      this.$refs.weight.fetch({
        volume: volume || defaultVolume,
        weight: weight || defaultWeight,
        sendOrderId, code, expressCode
      })
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.config.tallyOrderCode = ''
      this.$refs.table && this.$refs.table.clearSelection()
      this.list = []
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/getoutlist', {
        payload: {
          ...this.config,
          excludePrintTemplate: true
        },
        success: (res) => {
          this.loading = false
          const newList = []
          const newMap = {}
          res.data.data.records.forEach(i => {
            const sendOrderList = i.sendOrderList || []
            const sendOrder = sendOrderList[0] || {}
            if (i.combinedDeliveryNumber === 0 || !i.combinedDeliveryNumber) {
              newList.push({
                ...i,
                code: [i.code],
                packageNum: sendOrder.packageNum,
                sendOrderId: sendOrder.id,
                needInputWeightAndVolume: sendOrder.needInputWeightAndVolume,
                defaultVolume: sendOrder.defaultVolume,
                defaultWeight: sendOrder.defaultWeight,
                printErrorMsg: sendOrder.printErrorMsg,
                volume: sendOrder.volume,
                weight: sendOrder.weight
              })
            } else {
              const itemMap = newMap[i.combinedDeliveryNumber]
              if (itemMap === undefined) {
                newList.push({
                  ...i,
                  code: [i.code],
                  packageNum: sendOrder.packageNum,
                  sendOrderId: sendOrder.id,
                  needInputWeightAndVolume: sendOrder.needInputWeightAndVolume,
                  defaultVolume: sendOrder.defaultVolume,
                  defaultWeight: sendOrder.defaultWeight,
                  printErrorMsg: sendOrder.printErrorMsg,
                  volume: sendOrder.volume,
                  weight: sendOrder.weight
                })
                newMap[i.combinedDeliveryNumber] = newList.length - 1
              } else {
                const newListItem = newList[itemMap]
                newListItem.code.push(i.code)
                newList[itemMap] = newListItem
              }
            }
          })
          this.$set(this, 'list', newList)
          // this.list = res.data.data.records.map(i => {
          //   const sendOrderList = i.sendOrderList || []
          //   const sendOrder = sendOrderList[0] || {}
          //   return {
          //     ...i,
          //     packageNum: sendOrder.packageNum,
          //     sendOrderId: sendOrder.id,
          //     needInputWeightAndVolume: sendOrder.needInputWeightAndVolume,
          //     defaultVolume: sendOrder.defaultVolume,
          //     defaultWeight: sendOrder.defaultWeight,
          //     volume: sendOrder.volume,
          //     weight: sendOrder.weight
          //   }
          // })
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.tallyOrderCode = row.code
      this.toggleModal(true)
      this.fetchList(() => {})
    },
    resetFetch(ids) {
      this.$refs.table.clearSelection()
      this.fetchList(() => {
        this.list.forEach(i => {
          if (ids.indexOf(i.id) > -1) {
            this.$refs.table.toggleRowSelection(i, true)
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus">
.package-info {
  .el-form-item__label,.el-form-item__content {
    font-size 13px;
    line-height 24px
  }
}
 .el-table .warning-row-cus {
    background: oldlace;
  }
  .el-table .success-row-cus {
    background: rgb(240, 249, 235);
  }
</style>

